import React from 'react';
import TimeAgo from 'react-timeago';
import { Status } from '../Grid/components/UserAgents/components/UserAgent/styled';
import { CategoriesCell, CheckColum, CheckHeader, NameCell } from '../Table/components/columns';

/**
 * Cloud agents (security scanners) table.
 * ctx: `{ isFetching, show, intl }`
 */
const cloudAgentsSchema = {
  id: 'cloudAgents',
  loading: { mockRows: 13, skeleton: ({ isFetching }) => isFetching },
  columns: [
    {
      header: (_, { show }) => <CheckHeader disabled={ show } />,
      id: 'selected',
      accessor: 'selected',
      visible: true,
      sortable: false,
      resizable: false,
      maxWidth: 55,
      minWidth: 55,
      headerStyle: { overflow: 'visible' },
      style: { display: 'flex' },
      cell: ({ original }, { show }) => <CheckColum agent={ original }disabled={ show } />
    },
    {
      header: 'Name',
      accessor: 'name',
      id: 'name',
      visible: true,
      sortable: true,
      cell: ({ original }) => <NameCell agent={ original } />
    },
    {
      header: 'Status',
      accessor: 'status',
      id: 'status',
      visible: true,
      sortable: false,
      maxWidth: 150,
      minWidth: 150,
      cell: ({ value }, { intl }) => {
        const statusLabel = value ? intl.formatMessage({ id: `agents.item.status.${value}` }) : 'Online';
        return <Status value={ value || 'online' } children={ statusLabel } noMargin />;
      }
    },
    {
      header: (_, { intl }) => intl.formatMessage({ id: 'agents.cloudAgents.lastToolExecution' }),
      accessor: 'last_run',
      id: 'last_run',
      visible: true,
      sortable: false,
      cell: ({ value }) => <TimeAgo date={ value } />
    },
    {
      header: 'Description',
      accessor: 'description',
      id: 'description',
      visible: true,
      sortable: true,
      cell: ({ value }) => <div style={ { color: '#90a9c0', fontSize: '14.5px' } }>{value}</div>
    },
    {
      header: 'Categories',
      accessor: 'category',
      id: 'category',
      visible: true,
      sortable: false,
      minWidth: 150,
      cell: ({ original }) => <CategoriesCell agent={ original } isCloud />
    }
  ]
};

export default cloudAgentsSchema;
